var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"black footerPos"},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('div',{staticClass:"white--text"},[_c('a',{staticClass:"white--text",attrs:{"href":"https://electrowaves.fi"}},[_vm._v("Electro Waves Oy")]),_vm._v(" "),_c('v-icon',{staticClass:"blue--text"},[_vm._v("copyright")]),_vm._v("\n                2018\n            ")],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14861c15","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 263
// module chunks = 0